export const BASE_URL = "https://api.parking-pilot.com/"
